import { useAtomValue } from 'jotai';
import { IGenericSortable } from '../../../data-models/app-config.data-model';
import { sectorsAtom } from '../../../services/state/AppConfigStateJ';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { getSectorFields } from './SectorFields';

export function ConfigSector() {
  const sectors = useAtomValue(sectorsAtom);
  const transformBeforeSubmit = (data: IGenericSortable): IGenericSortable => {
    return {
      ...data,
      displayName: data.name,
      sortOrder: 0,
    };
  };

  return (
    <GenericConfigPage
      baseTitle={'Sector'}
      data={sectors}
      fields={[]}
      formFields={getSectorFields()}
      pageTitle={'Sectors'}
      queryURL={'/sector'}
      transformBeforeSubmit={transformBeforeSubmit}
    />
  );
}
